module.exports = __webpack_public_path__ + "static/fonts/menu-explore-selected.svg";